import { render, staticRenderFns } from "./dashboard-container.vue?vue&type=template&id=52f3d04d"
import script from "./dashboard-container.vue?vue&type=script&lang=js"
export * from "./dashboard-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports